import React, { useEffect, useState } from "react";
import DetailPageNavBar from "../../../../containers/DetailPageNavbar";
import { Link, useLocation, useParams } from "react-router-dom";
import { Leads } from "../../../../api/Endpoints/Leads";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  IconButton,
  TextField,
} from "@mui/material";
import LabelsList from "../../../../components/CommonFunctions/LabelsList";
import LabelsComponent from "../../../../components/Form/LabelComponent";
import AssignTo from "../../../../components/Form/AssignTo";
import moment from "moment";
import StatusSelector from "../../../../components/Form/Status";
import StatusLIstFunction from "../../../../components/CommonFunctions/statusLIst";
import DateInput from "../../../../components/Form/DateInput";
import { useForm } from "react-hook-form";
import AddNotes from "./AddNotes";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import Source from "../Tabs/Source";
import SiteVisitTab from "../Tabs/SiteVisit";
import ExtraData from "../Tabs/ExtraData";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import WhatsAppChatBox from "./WhatsappChatBox";
import toast from "react-hot-toast";
function Index() {
  const { leadid } = useParams();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const {
    watch,
    formState: { errors },
    control,
    Controller,
    setValue,
  } = useForm({});
  const { statusList, fetchStatusList } = StatusLIstFunction();
  const { labels, isLoading } = LabelsList();

  const location = useLocation();

  const getQueryParameter = (key) => {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get(key);
  };

  const pageNumber = getQueryParameter("page");
  const slug = getQueryParameter("slug");
  const home = getQueryParameter("home");

  const navigate = useNavigate();

  useEffect(async () => {
    setLoading(true);
    await fetchStatusList();
    fetchDetails();
  }, [leadid]);

  const fetchDetails = () => {
    Leads.getDetails({ id: leadid })
      .then((response) => {
        setData(response.data.lead);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const [chatBoxOpen, setChatBoxOpen] = useState(false);
  const [editingBudget, setEditingBudget] = useState(false);
  const [budgetValue, setBudgetValue] = useState("");

  const handleOpen = () => {
    if (!data?.assigned_to) {
      return toast.error("User Assignment Required", {
        autoClose: 2000,
        position: "top-center",
      });
    }

    setChatBoxOpen(true);
  };
  const handleClose = () => {
    setChatBoxOpen(false);
  };

  const AssignedCheck = () => {};

  const handleEditBudget = () => {
    setBudgetValue(data?.client_budget || "");
    setEditingBudget(true);
  };

  const handleSaveBudget = async () => {
    try {
      const response = await Leads.update({
        id: leadid,
        client_budget: budgetValue,
      });

      if (response.data.status) {
        toast.success("Client Budget updated successfully!", {
          position: "top-center",
        });
        setEditingBudget(false);
        fetchDetails(); // Refresh the data
      } else {
        toast.error(response.data.message || "Failed to update budget", {
          position: "top-center",
        });
      }
    } catch (error) {
      console.error("Error updating budget:", error);
      toast.error("Failed to update budget", {
        position: "top-center",
      });
    }
  };

  const handleCancelBudget = () => {
    setEditingBudget(false);
    setBudgetValue("");
  };

  return (
    <>
      <div className="cnt-cntr-details">
        <div className="fixe-menu-detail">{<DetailPageNavBar />}</div>
      </div>
      <div className="go-back-btn"></div>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "30vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <div className="details-page-block-content">
          <div class="detail-page-left-block">
            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.1rem" }}
              >
                Lead Type:
              </Typography>
              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.crm_lead_type?.name}
              </Typography>
            </div>
            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.1rem" }}
              >
                Project:
              </Typography>
              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.project?.name}
              </Typography>
            </div>
            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.1rem" }}
              >
                Preferred Project:
              </Typography>
              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.preferred_project?.name}
              </Typography>
            </div>
            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.1rem" }}
              >
                Customer Name:
              </Typography>

              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.name}
              </Typography>
            </div>

            <div
              class="pop-det-text"
              style={{ justifyContent: "space-between" }}
            >
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.1rem" }}
              >
                Phone Number:
              </Typography>

              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.phone_number}
              </Typography>
              <IconButton
                onClick={handleOpen}
                sx={{
                  background: "#25D366",
                  color: "white",
                  "&:hover": {
                    background: "#25D366", // Keep the same color on hover
                  },
                }}
              >
                <WhatsAppIcon />
              </IconButton>
            </div>
            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.1rem" }}
              >
                Alternative Phone Number:
              </Typography>

              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.alt_phone_number}
              </Typography>
            </div>

            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.1rem" }}
              >
                Email:
              </Typography>

              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.email}
              </Typography>
            </div>

            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.0rem" }}
              >
                Age:
              </Typography>
              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.age_range}
              </Typography>
            </div>

            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.0rem" }}
              >
                Profession:
              </Typography>
              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.profession}
              </Typography>
            </div>
            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.0rem" }}
              >
                Location:
              </Typography>
              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.city}
              </Typography>
            </div>

            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.0rem" }}
              >
                Client Budget:
              </Typography>
              {editingBudget ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <TextField
                    size="small"
                    value={budgetValue}
                    onChange={(e) => setBudgetValue(e.target.value)}
                    placeholder="Enter budget"
                    variant="outlined"
                    autoFocus
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSaveBudget();
                      } else if (e.key === "Escape") {
                        handleCancelBudget();
                      }
                    }}
                  />
                  <IconButton
                    size="small"
                    onClick={handleSaveBudget}
                    color="success"
                  >
                    <SaveIcon />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={handleCancelBudget}
                    color="error"
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              ) : (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography
                    variant="body2"
                    style={{
                      display: "inline",
                      paddingLeft: 10,
                      fontSize: "16px",
                      color: data?.client_budget ? "inherit" : "#999",
                    }}
                  >
                    {data?.client_budget || "Not set"}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={handleEditBudget}
                    sx={{ color: "#6f6f6f" }}
                    title={data?.client_budget ? "Edit budget" : "Add budget"}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Box>
              )}
            </div>

            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.0rem" }}
              >
                Country:
              </Typography>
              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.country?.name}
              </Typography>
            </div>
            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.0rem" }}
              >
                City:
              </Typography>
              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              ></Typography>
            </div>
            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.0rem" }}
              >
                Requsted Date:
              </Typography>
              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {moment(data?.created_at).format("DD-MM-YYYY")}
              </Typography>
            </div>

            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.0rem" }}
              >
                Lead Source:
              </Typography>
              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              ></Typography>
            </div>
            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.0rem" }}
              >
                Referred By:
              </Typography>
              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.referred_by}
              </Typography>
            </div>

            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.0rem" }}
              >
                Description:
              </Typography>
              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.remarks}
              </Typography>
            </div>
            <div class="pop-det-text">
              <Typography
                variant="body1"
                component="h2"
                style={{ fontWeight: "bold", fontSize: "1.0rem" }}
              >
                Campaign Name:
              </Typography>
              <Typography
                variant="body2"
                style={{ display: "inline", paddingLeft: 10, fontSize: "16px" }}
              >
                {data?.campaign_name}
              </Typography>
            </div>
            <Source
              func={fetchDetails}
              viewID={leadid}
              sources={data}
              hideEditBtn={true}
            />
          </div>

          <div className="detail-page-right-block">
            <div className="detail-page-right-block-inner">
              <div class="pop-det-text">
                <Typography
                  variant="body1"
                  component="h2"
                  style={{ fontWeight: "bold", fontSize: "1.1rem" }}
                >
                  Status:
                </Typography>
                <StatusSelector
                  statusList={statusList}
                  options={data?.crm_status_details}
                  id={data?.id}
                />
              </div>

              <div class="pop-det-text">
                <Typography
                  variant="body1"
                  component="h2"
                  style={{ fontWeight: "bold", fontSize: "1.1rem" }}
                >
                  Next Follow Up Date:
                </Typography>
                <DateInput
                  id={leadid} // Pass the unique identifier for this specific date field
                  name={`follow_up_date - ${leadid} `}
                  // Provide a unique name for each date field
                  setValue={setValue}
                  control={control}
                  value={data?.follow_up_date}
                />
              </div>

              <div class="pop-det-text">
                <Typography
                  variant="body1"
                  component="h2"
                  style={{ fontWeight: "bold", fontSize: "1.0rem" }}
                >
                  Assign To:
                </Typography>
                <Button size="small" style={{ color: "#6f6f6f" }}>
                  <AssignTo
                    id={leadid}
                    isAssigned={data?.assigned_to_details}
                    // isDisable={ }whatsapp
                    DtView={data?.assigned_to_details?.id ? true : false}
                    control={control}
                  />
                </Button>
              </div>
              <div class="pop-det-text">
                <Typography
                  variant="body1"
                  component="h2"
                  style={{ fontWeight: "bold", fontSize: "1.0rem" }}
                >
                  Label:
                </Typography>
                <LabelsComponent
                  viewID={leadid}
                  currentLabel={data?.label}
                  isLoading={isLoading}
                  lablesList={labels}
                  func={fetchDetails}
                />
              </div>
            </div>
            <div>
              <ExtraData data={data} />
            </div>
            <div
              style={{
                padding: "14px",
                border: "1px solid #cfcfcf",
              }}
            >
              <SiteVisitTab data={data} func={fetchDetails} viewID={leadid} />
            </div>

            <div
              className="full-detail-note-block"
              style={{
                padding: "14px",
                border: "1px solid #cfcfcf",
                marginTop: 14,
              }}
            >
              <AddNotes viewID={leadid} />
            </div>
          </div>
        </div>
      )}
      {chatBoxOpen && (
        <WhatsAppChatBox
          handleClose={handleClose}
          open={chatBoxOpen}
          id={leadid}
          leadDetails={data}
          setChatBoxOpen={setChatBoxOpen}
        />
      )}
    </>
  );
}

export default Index;
